type MouseIconProps = {
  color?: string;
  width?: string;
  height?: string;
}

export const MouseIcon = ({
  color = '#363BC4', width = '14', height = '14', ...props
}: MouseIconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1.647 6.212c-.372-.144-.557-.216-.612-.32a.31.31 0 0 1 0-.288c.054-.104.24-.177.611-.322L12.183 1.17c.336-.13.503-.196.61-.16a.31.31 0 0 1 .197.197c.036.107-.03.274-.16.61L8.718 12.354c-.145.371-.218.557-.322.61a.31.31 0 0 1-.288 0c-.104-.053-.176-.24-.32-.61l-1.64-4.217c-.03-.076-.044-.114-.067-.145a.3.3 0 0 0-.073-.073c-.031-.023-.07-.037-.145-.067z"
    />
  </svg>
);
